import { Button } from '@timelyapp/react';
import React from 'react';
import styles from './AutoSheetsSettingsRoute.module.scss';

/** Copy shared by both pages for the three settings an admin may enforce. */
export const ENFORCEABLE_SETTINGS_LABEL = 'time entry length, daily generation and note language';

interface FieldRowProps {
  label: React.ReactNode;
  /** One line under the label saying what the setting changes. */
  hint?: string;
  children: React.ReactNode;
}

/**
 * One settings row: label (with an optional hint under it) on the left, the
 * control on the right. Shared by the personal and the workspace AutoSheet
 * settings pages so the same setting looks the same on both.
 */
export const FieldRow: React.FC<FieldRowProps> = ({ label, hint, children }) => (
  <div className={styles.fieldRow}>
    <div className={styles.fieldText}>
      <span className={styles.fieldLabel}>{label}</span>
      {hint && <div className={styles.fieldHint}>{hint}</div>}
    </div>
    <div className={styles.fieldControl}>{children}</div>
  </div>
);

interface ConfirmRowProps {
  message: string;
  confirmLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
}

/** The second step of a two-step destructive action, inline where the action sat. */
export const ConfirmRow: React.FC<ConfirmRowProps> = ({
  message,
  confirmLabel,
  onConfirm,
  onCancel,
}) => (
  <div className={styles.resetConfirm}>
    <span>{message}</span>
    <div className={styles.resetActions}>
      <Button priority="low" size="small" onClick={onCancel}>
        Cancel
      </Button>
      <Button priority="high" size="small" onClick={onConfirm}>
        {confirmLabel}
      </Button>
    </div>
  </div>
);
